// assets\resources\js\app.js

const currentScriptSrc = document.currentScript?.src
    || Array.from(document.scripts)
        .map((script) => script?.src)
        .filter(Boolean)
        .reverse()
        .find((src) => src.includes('/themes/') && src.includes('/assets/build/js/app.js'));

if (currentScriptSrc) {
    __webpack_public_path__ = new URL('../', currentScriptSrc).toString();
}

import './core/icons';
import {ready} from './core/dom';
import {initBootstrap} from './core/bootstrap';
import {autoloadModules} from './core/autoload';

ready(async () => {
    initBootstrap();
    await autoloadModules();
    const page = document.body.dataset.page;
    if (page) {
        try {
            await import(`./pages/${page}.js`).then((m) => m.default && m.default());
        } catch (_e) {
        }
    }
});
